function watch(propertyName, options) {
  const resolvedOptions = {
    waitUntilFirstUpdate: false,
    lifecycleMethod: "update",
    ...options
  };
  return (proto, decoratedFnName) => {
    const method = proto[resolvedOptions.lifecycleMethod];
    const watchedProperties = Array.isArray(propertyName) ? propertyName : [propertyName];
    proto[resolvedOptions.lifecycleMethod] = function(changedProps) {
      if (resolvedOptions.lifecycleMethod === "willUpdate") {
        method.call(this, changedProps);
      }
      watchedProperties.forEach((property) => {
        const key = property;
        if (changedProps.has(key)) {
          const oldValue = changedProps.get(key);
          const newValue = this[key];
          if (oldValue !== newValue) {
            if (!resolvedOptions.waitUntilFirstUpdate || this.hasUpdated) {
              this[decoratedFnName](oldValue, newValue);
            }
          }
        }
      });
      if (resolvedOptions.lifecycleMethod === "update") {
        method.call(this, changedProps);
      }
    };
  };
}
export {
  watch
};
//# sourceMappingURL=watch.js.map
